import { Component, Input, OnInit } from '@angular/core';
import {
  FormGroup,
  ControlContainer,
  FormGroupDirective,
} from '@angular/forms';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class ColorPickerComponent implements OnInit {
  /**
   * * General
   * @errors Form control errors
   * @specificFormGroup Set custom form group
   */
  errors: any = {};
  specificFormGroup: FormGroup;

  color: string;
  /**
   * * Inputs
   * @options Configuration for this form field
   * @customFormGroup Used when you want to use this component without form-builder
   */
  @Input() options: any;
  @Input() customFormGroup: any;
  @Input() customFormGroupName: any;

  constructor(public controlContainer: ControlContainer) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    if (this.options.fieldFormGroup || this.options.fieldFormGroup == '') {
      this.specificFormGroup = this.getSpecificFormGroup(
        this.options.fieldFormGroup
      );
    } else {
      this.specificFormGroup = this.customFormGroup;
    }
    if (this.options.fieldFormGroup == '') {
      this.specificFormGroup = this.customFormGroup;
    }

    this.controlContainer.control
      .get(this.options.formControlName)
      .valueChanges.subscribe((value) => {
        this.color = value;
      });

    this.color = this.options.value;

    // this.specificFormGroup = this.options.fieldFormGroup !== '' ? this.getSpecificFormGroup(this.options.fieldFormGroup) : this.customFormGroup;
  }

  /* ====================================
  *                HELPERS
  ======================================= */

  onChange(event: Event) {
    const formGroup = this.controlContainer.control as FormGroup;

    if (this.customFormGroup && this.options.fieldFormGroup !== undefined) {
      this.errors =
        this.customFormGroup.controls[this.options.formControlName].errors;
    } else if (
      this.customFormGroup &&
      (this.options.fieldFormGroup || this.options.fieldFormGroup == '')
    ) {
      this.errors = formGroup.controls[this.options.formControlName].errors;
    } else {
      this.errors = formGroup.controls[this.options.formControlName].errors;
    }

    this.errors = { errorMessage: this.options.errorMessage, ...this.errors };
  }

  onChangeColor(event) {
    this.controlContainer.control
      .get(this.options.formControlName)
      .setValue(event.value);
  }

  getSpecificFormGroup(formGroupPath: string) {
    return <FormGroup>this.customFormGroup.get(formGroupPath);
  }
}
